export default "__VITE_PUBLIC_ASSET__e462b850__"